import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { LoginService } from '../../auth/login.service';

/**
 * Twin of CRM PermissionGuard: product session + fail-closed permissions.
 * Shell Portal routes use `data.allowAuthenticated` (platform gate only).
 * Feature routes must declare `data.permissions`.
 */
export const PermissionGuard: CanActivateFn = route => {
  const loginService = inject(LoginService);
  const router = inject(Router);

  return loginService.ensureSession().pipe(
    map(ok => {
      if (!ok) {
        router.navigate(['/login']);
        return false;
      }

      if (!loginService.hasUsableSession()) {
        router.navigate(['/login']);
        return false;
      }

      if (route.data['allowAuthenticated'] === true) {
        return true;
      }

      const required = route.data['permissions'] as string[] | undefined;
      if (!required || required.length === 0) {
        router.navigate(['/profile']);
        return false;
      }

      if (!loginService.hasAnyPermission(required)) {
        router.navigate(['/login']);
        return false;
      }

      return true;
    })
  );
};
